import { Button, Modal } from 'react-bootstrap';

const ErrorModal = ({ handleClose, show, message }) => {
    const reload = () => window.location.reload();
    
    return (
        <Modal show={show} onHide={() => {handleClose(); reload()}}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    System Message
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{message}</p>
                <Button
                    variant='outline-secondary'
                    onClick={() => {handleClose(); reload()}}
                    style={{ float: 'right' }}
                >
                    Close
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default ErrorModal;
